var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-alert',{attrs:{"variant":_vm.alertVariant,"show":""}},[_c('div',{staticClass:"alert-heading"},[_vm._v(_vm._s(_vm.decisionTitle))]),(_vm.decision.comment)?_c('p',{staticClass:"preserve-linebreak"},[_vm._v(" "+_vm._s(_vm.decision.comment)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }